<template>
  <div class="mainWrapper">
     <!-- <ParentTabComponent v-if="showParentTabComponent"/> -->
    <router-view />
  </div>
</template>

<script>
import './assets/css/stylesheet.css'
import './assets/css/luckyNumber.css'
// import DefaultComponent from './components/DefaultComponent.vue'

import { computed } from 'vue';
import { useRoute } from 'vue-router';
export default {
  name: 'App',
  components: {
    // DefaultComponent
  },
  setup() {
    const route = useRoute();
    const showParentTabComponent = computed(() => {
      return !route.path.startsWith('/Mylevel');
    });

    return {
      showParentTabComponent
    };
  },

  watch: {
    $route(to) {
      if (to.path.includes("fans_ranking")) {
        document.body.classList.add("fansRanking-page");
      } else {
        document.body.classList.remove("fansRanking-page");
      }
    },
  },
  mounted() {
    // Also run once on initial load
    if (this.$route.path.includes("fans_ranking")) {
      document.body.classList.add("fansRanking-page");
    }
  },
}
</script>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200..1000;1,200..1000&display=swap');
  body {font-family: "Mulish", sans-serif;}
</style>
